export default "__VITE_ASSET__da5e2440__"